
/* Digilog.pk Advanced Search — typo correction, synonyms, popular searches, analytics */
(function () {
  'use strict';

  /* ── Typo corrections & synonyms map ── */
  const CORRECTIONS = {
    // Arduino typos
    'aurdino':'arduino','ardino':'arduino','ardueno':'arduino',
    'arduiono':'arduino','ardiuno':'arduino','ardunio':'arduino',
    // ESP typos
    'esp-32':'esp32','esp 32':'esp32','esp3':'esp32',
    'esp-8266':'esp8266','esp 8266':'esp8266','nodemicu':'nodemcu','node mcu':'nodemcu',
    // Component typos
    'resister':'resistor','ressistor':'resistor','resistore':'resistor',
    'capasitor':'capacitor','capaciter':'capacitor','capacitir':'capacitor',
    'transister':'transistor','transistore':'transistor',
    'blutooth':'bluetooth','blueetooth':'bluetooth','bluetoth':'bluetooth','bleutooth':'bluetooth',
    'raspbery pi':'raspberry pi','raspberry pie':'raspberry pi',
    'soldering irun':'soldering iron','sodlering':'soldering','solderng':'soldering',
    'realy':'relay','reley':'relay','relai':'relay',
    'steper motor':'stepper motor','stepper moter':'stepper motor',
    'sevo motor':'servo motor','servo moter':'servo motor',
    'bred board':'breadboard','bread bord':'breadboard','bredboard':'breadboard',
    'lcl display':'lcd display','ldc':'lcd',
    'ocsilloscope':'oscilloscope','osciloscope':'oscilloscope',
    'mulitimeter':'multimeter','multimetre':'multimeter',
    // Synonyms — concept to product
    'wifi module':'esp8266','wireless module':'esp32 wifi',
    'microcontroller board':'arduino','micro controller':'arduino',
    'microcontroller':'arduino esp32',
    'motor driver':'l298n','voltage regulator':'lm7805 voltage regulator',
    'temp sensor':'dht22','temperature sensor':'dht22 temperature',
    'humidity sensor':'dht11 dht22','distance sensor':'hc-sr04 ultrasonic',
    'ultrasonic sensor':'hc-sr04','gyroscope sensor':'mpu6050',
    'imu sensor':'mpu6050','accelerometer':'mpu6050 accelerometer',
    'bluetooth module':'hc-05 bluetooth','gsm module':'sim800l gsm',
    'gps module':'neo-6m gps','oled screen':'oled display',
    'battery charger':'tp4056 charger','18650 charger':'tp4056',
    'power module':'buck converter','step down converter':'lm2596 buck',
    'step up converter':'mt3608 boost','boost converter':'mt3608',
    'ir sensor':'infrared sensor','light sensor':'ldr photoresistor',
    'gas sensor':'mq-2 gas','smoke detector':'mq-2 smoke sensor',
    'rain sensor':'rain water sensor','soil sensor':'soil moisture sensor',
    'pressure sensor':'bmp280 pressure','barometric sensor':'bmp280',
    'rtc module':'ds3231 rtc','real time clock':'ds3231',
    'sd card module':'micro sd card module','7 segment':'7 segment display',
    'seven segment':'7 segment display','dot matrix':'led matrix display',
    'servo motor small':'sg90 servo','big servo':'mg996r servo',
    'stepper driver':'a4988 drv8825 stepper driver',
    'nema 17':'nema17 stepper','laser module':'laser diode module',
    'fan controller':'pwm fan controller','oscilloscope probe':'dso oscilloscope',
    'digital meter':'digital multimeter','helping hand':'pcb holder helping hand',
    'wire stripper':'cable wire stripper','heat shrink':'heat shrink tube',
    'jumper wire':'dupont jumper wire','current sensor':'acs712 current sensor',
    'color sensor':'tcs3200 color sensor','fingerprint':'r307 fingerprint module',
    'rfid':'rc522 rfid module','rfid module':'rc522 rfid',
    'touch sensor':'capacitive touch sensor','joystick':'joystick module',
    'keypad':'4x4 keypad matrix','rotary encoder':'rotary encoder module',
  };

  /* ── Popular searches for digilog.pk ── */
  const POPULAR = [
    'Arduino Uno', 'ESP32', 'ESP8266', 'NodeMCU',
    'Raspberry Pi', 'Relay Module', 'OLED Display',
    'DHT22 Sensor', 'L298N Motor Driver', 'HC-SR04',
    'LiPo Battery', 'Soldering Iron', 'Breadboard',
    'Servo Motor', 'Stepper Motor', 'Buck Converter',
  ];

  /* ── Query correction ── */
  function correctQuery(q) {
    const lower = q.trim().toLowerCase();
    if (CORRECTIONS[lower]) return CORRECTIONS[lower];
    // Partial match: check if query starts with a known key
    for (const [wrong, right] of Object.entries(CORRECTIONS)) {
      if (lower.startsWith(wrong)) return right + lower.slice(wrong.length);
    }
    return null;
  }

  /* ── Intercept search form submit ── */
  function interceptForms() {
    document.querySelectorAll('form[action*="/search"]').forEach(form => {
      if (form.dataset.corrected) return;
      form.dataset.corrected = '1';
      form.addEventListener('submit', e => {
        const input = form.querySelector('input[name="q"]');
        if (!input) return;
        const corrected = correctQuery(input.value);
        if (corrected) input.value = corrected;
        // GA4
        trackSearch(input.value);
      });
    });
  }

  /* ── Intercept predictive search API calls ──
     Fixes:
     1. AbortController: abort stale in-flight request before each new one
     2. Min 2-char query: skip single-char searches (aborted silently by Kalles catch code 20)
     3. Typo correction still applied for valid queries
  ── */
  let _psAbort = null;

  const _fetch = window.fetch;
  window.fetch = function(url, ...args) {
    if (typeof url === 'string' && url.includes('/search/suggest') && url.includes('q=')) {
      try {
        const u = new URL(url, location.origin);
        const q = u.searchParams.get('q') || '';

        // Abort previous in-flight request
        if (_psAbort) _psAbort.abort();
        _psAbort = new AbortController();

        if (q.trim().length < 2) {
          // Too short — abort immediately, Kalles catch(error.code===20) handles silently
          _psAbort.abort();
        } else {
          const corrected = correctQuery(q);
          if (corrected) {
            u.searchParams.set('q', corrected);
            url = u.toString();
          }
        }

        // Replace stale signal from Kalles (abortController2 is never refreshed in custom.js)
        const opts = args[0] || {};
        args[0] = { ...opts, signal: _psAbort.signal };
      } catch {}
    }
    return _fetch.call(this, url, ...args);
  };

  /* ── GA4 Search Analytics ── */
  function trackSearch(term) {
    if (!term || term.length < 2) return;
    // GA4 gtag
    if (window.gtag) {
      gtag('event', 'search', { search_term: term });
    }
    // Also push to dataLayer for GTM
    if (window.dataLayer) {
      dataLayer.push({ event: 'site_search', search_term: term });
    }
  }

  /* ── Track predictive result clicks ── */
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="/search?"]');
    if (!a) return;
    try {
      const term = new URL(a.href).searchParams.get('q');
      if (term) trackSearch(term);
    } catch {}
  }, true);

  /* ── Popular searches in dropdown ── */
  const STORAGE_KEY = 'digilog_recent_searches';
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  }

  function buildPopularSection(input) {
    const div = document.createElement('div');
    div.className = 'hdt-rsm-popular';
    div.innerHTML = `
      <div class="hdt-rsm-pop-header">
        <span class="hdt-rsm-label">Popular Searches</span>
      </div>
      <div class="hdt-rsm-pop-tags">
        ${POPULAR.map(t => `<button class="hdt-rsm-pop-tag" type="button">${t}</button>`).join('')}
      </div>`;
    div.querySelectorAll('.hdt-rsm-pop-tag').forEach(btn => {
      btn.addEventListener('click', () => {
        input.value = btn.textContent;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        const form = input.closest('form');
        if (form) {
          trackSearch(btn.textContent);
          form.submit();
        }
      });
    });
    return div;
  }

  /* Extend the existing hdt-rsm-dropdown to include popular searches when no recents */
  function maybeAddPopular(input) {
    setTimeout(() => {
      const dropdown = input.closest('.hdt-rsm-anchor')?.querySelector('.hdt-rsm-dropdown')
                    || document.querySelector('.hdt-rsm-dropdown');
      if (!dropdown) {
        // No recent searches dropdown — show popular only
        if (!input.value.trim()) showPopularOnly(input);
      } else if (!getRecent().length) {
        dropdown.appendChild(buildPopularSection(input));
      } else {
        // Has recents — append popular at bottom
        if (!dropdown.querySelector('.hdt-rsm-popular')) {
          dropdown.appendChild(buildPopularSection(input));
        }
      }
    }, 50);
  }

  function showPopularOnly(input) {
    let anchor = input.closest('.hdt-rsm-anchor');
    if (!anchor) {
      anchor = input.parentElement;
      anchor.classList.add('hdt-rsm-anchor');
      anchor.style.position = 'relative';
    }
    if (anchor.querySelector('.hdt-rsm-pop-only')) return;
    const wrap = document.createElement('div');
    wrap.className = 'hdt-rsm-dropdown hdt-rsm-pop-only';
    wrap.appendChild(buildPopularSection(input));
    anchor.appendChild(wrap);

    input.addEventListener('input', () => {
      if (input.value.trim()) wrap.remove();
    }, { once: true });
    input.addEventListener('blur', () =>
      setTimeout(() => wrap.remove(), 200), { once: true });
  }

  /* ── "Did you mean" on zero-results page ── */
  function initZeroResults() {
    const emptyEl = document.querySelector('.hdt-search-empty');
    if (!emptyEl) return;

    const params = new URLSearchParams(location.search);
    const query  = params.get('q') || '';
    if (!query) return;

    const corrected = correctQuery(query);

    // Did you mean?
    if (corrected && corrected.toLowerCase() !== query.toLowerCase()) {
      const didYouMean = document.createElement('div');
      didYouMean.className = 'hdt-dym';
      didYouMean.innerHTML = `
        Did you mean:
        <a href="/search?q=${encodeURIComponent(corrected)}&type=product"
           class="hdt-dym-link">${corrected}</a>?`;
      emptyEl.appendChild(didYouMean);
    }

    // Popular categories grid
    const cats = document.createElement('div');
    cats.className = 'hdt-zero-cats';
    cats.innerHTML = `
      <p class="hdt-zero-cats__title">Try searching for:</p>
      <div class="hdt-zero-cats__grid">
        ${POPULAR.map(t =>
          `<a href="/search?q=${encodeURIComponent(t)}&type=product"
              class="hdt-zero-cat-tag">${t}</a>`
        ).join('')}
      </div>
      <p class="hdt-zero-cats__browse">
        Or <a href="/collections/all" class="hdt-zero-cats__link">browse all products</a>
      </p>`;
    emptyEl.appendChild(cats);
  }

  /* ── Init ── */
  function wireInputs() {
    document.querySelectorAll('input[type="search"], input[name="q"]').forEach(input => {
      if (input.dataset.advWired) return;
      input.dataset.advWired = '1';
      input.addEventListener('focus', () => maybeAddPopular(input));
    });
    interceptForms();
  }

  document.addEventListener('DOMContentLoaded', () => {
    wireInputs();
    initZeroResults();
  });
  new MutationObserver(wireInputs).observe(document.body || document.documentElement,
    { childList: true, subtree: true });


  /* Also patch the form submit so pressing Enter includes options params */
  document.addEventListener('submit', e => {
    const form = e.target.closest('form[action*="/search"]');
    if (!form) return;
    ['options[fields]', 'options[prefix]'].forEach(name => {
      if (form.querySelector('[name="' + name + '"]')) return; // already has it
    });
    // options[fields] and options[prefix] are added as hidden fields via search-form.liquid
    // This listener is a safety net for any other search forms on the page
  }, true);



  /* ── Full search URL fix ──
     When Enter is pressed or "View all" is clicked, Shopify's full-page search
     needs options[fields] to search the same fields as predictive (body, tag, SKU).
     This also produces a clean URL — no predictive-only resources[*] params.
  ── */
  (function () {
    var FS_FIELDS = 'title,body,tag,product_type,variants.title,vendor,variants.sku';

    /* Form submit → clean URL */
    document.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      var form = e.target && e.target.closest('form[action*="/search"]');
      if (!form) return;
      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var q = input.value.trim();

      // Include category filter if a product_type is selected
      var catSelect = form.querySelector('[data-cat-search] select');
      if (catSelect && catSelect.value && catSelect.value !== '*') {
        q = q ? 'product_type:' + catSelect.value + ' AND ' + q : 'product_type:' + catSelect.value;
      }

      var params = new URLSearchParams();
      params.set('q', q);
      params.set('type', 'product');
      params.set('options[prefix]', 'last');
      params.set('options[fields]', FS_FIELDS);
      window.location.href = '/search?' + params.toString();
    }, false);

    /* "View all" and other /search?q= links → add options params cleanly */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest('a[href*="/search"]');
      if (!a) return;
      try {
        var u = new URL(a.href, location.origin);
        if (!u.searchParams.has('q')) return;
        if (u.searchParams.has('options[fields]')) return;
        u.searchParams.set('type', 'product');
        u.searchParams.set('options[prefix]', 'last');
        u.searchParams.set('options[fields]', FS_FIELDS);
        // Remove predictive-only params that pollute the URL
        u.searchParams.delete('resources[limit_scope]');
        u.searchParams.delete('resources[options][fields]');
        u.searchParams.delete('resources[type]');
        a.href = u.pathname + '?' + u.searchParams.toString();
      } catch (err) {}
    }, true);
  })();
})();